import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { BRIDGE_TABS, type BridgeTab } from '@/features/admin/shared/tabs';
import { BridgeDetailPage } from '@/features/admin/bridges/bridge-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Détail d'un bridge. L'onglet actif vit dans l'URL (`?tab=`). */
export const Route = createFileRoute('/$tenant/bridges/$bridgeId')({
  validateSearch: (search: Record<string, unknown>): { tab: BridgeTab } => ({
    tab: BRIDGE_TABS.parse(search['tab']),
  }),
  component: BridgeRoute,
});

function BridgeRoute() {
  const { tenant, bridgeId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="bridges"
      crumbs={[{ label: t('nav.items.bridges') }, { label: bridgeId, mono: true }]}
    >
      <BridgeDetailPage
        tenantId={tenant}
        bridgeId={bridgeId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
